import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import FlightLandIcon from '@mui/icons-material/FlightLand';
import { Stack, Typography } from '@mui/material';
import formatSecondsToHours from 'legacyfrontend/utils/formatSecondsToHours';

const KindOfFlightCard = ({ isVueloDeIda, isVueloDeVuelta, originId, destinationId, duration }) => (
  <Stack
    flexDirection='row'
    justifyContent='space-between'
    padding={1}
    paddingLeft={2}
    paddingRight={2}
    sx={{ backgroundColor: '#1111' }}
  >
    <Stack flexDirection='row' gap={1}>
      {isVueloDeIda && (
        <>
          <FlightTakeoffIcon />
          <Typography>Vuelo de ida</Typography>
        </>
      )}
      {isVueloDeVuelta && (
        <>
          <FlightLandIcon />
          <Typography>Vuelo de vuelta</Typography>
        </>
      )}
      <Typography>{`${originId} - ${destinationId}`}</Typography>
    </Stack>
    <Typography>{`Duración total: ${formatSecondsToHours(duration)}`}</Typography>
  </Stack>
);

export default KindOfFlightCard;
